import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { InventoryLocationSelectProps } from "../../common/types"
import { InventoryLocationAction } from "../../state/inventory/location/actions"
import { InventoryLocationSelector } from "../../state/inventory/location/selectors"

export const InventoryLocationSelect = (props: InventoryLocationSelectProps) => {
    const listing = useSelector(InventoryLocationSelector.getListing)
    const apiStatus = useSelector(InventoryLocationSelector.getApiStatus)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!apiStatus.isLoaded) {
            dispatch(InventoryLocationAction.fetchListing())
        }
    }, [])

    const selectOptions = useMemo(() => {
        return listing.map(item => {
            return {
                value: item.id,
                label: item.name
            }
        })
    }, [listing.length])

    const handleChange = (selected) => {
        props.onChangeCallback(selected)
    }

    return (
        <Select
            isClearable={false}
            className={props.className ?? ""}
            menuPortalTarget={document.body}
            value={props.selectedValue}
            options={selectOptions}
            onChange={handleChange}
        />
    )
}


// WEBPACK FOOTER //
// ./src/inventory/components/InventoryLocationSelect.tsx